import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.3_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.19_db0@0.3.2_e_72f7c991f442de09c7dad6ce52096d83/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/buildhome/repo/middleware/auth.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.3_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.19_db0@0.3.2_e_72f7c991f442de09c7dad6ce52096d83/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  guest: () => import("/opt/buildhome/repo/middleware/guest.ts")
}